export default {
    base: {
        color: '#4A4A4A',
        fontWeight: '500',
        fontFamily: 'Open Sans, sans-serif',
        fontSize: '18px',

        backgroundColor: '#fff',

        '::placeholder': {
            color: '#A1AFC3',
        }
    },
    invalid: {
        color: '#FFC7EE'
    }
}